import { useEffect, useState } from 'react';
import supabase from '../../supabase/supabase';
import { getClientId } from '../../utils/clientIdentity';

export default function usePresence(nickname) {
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    if (!nickname) {
      setOnlineUsers([]);
      return undefined;
    }

    const channel = supabase.channel('gallo_chat_presence', {
      config: {
        presence: {
          key: getClientId()
        }
      }
    });

    const syncPresence = () => {
      const users = Object.values(channel.presenceState())
        .flat()
        .map((presence) => presence.nickname)
        .filter(Boolean);

      setOnlineUsers(
        [...new Set(users)].sort((a, b) => a.localeCompare(b))
      );
    };

    channel
      .on('presence', { event: 'sync' }, syncPresence)
      .on('presence', { event: 'join' }, syncPresence)
      .on('presence', { event: 'leave' }, syncPresence)
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({
            nickname,
            client_id: getClientId(),
            online_at: new Date().toISOString()
          });
        }
      });

    return () => {
      channel.untrack();
      supabase.removeChannel(channel);
    };
  }, [nickname]);

  return onlineUsers;
}